/**
 * Canonical free-tier plan limits for Budgit.
 *
 * The backend gate (backend/middleware/premium.js) enforces these, and the
 * marketing site's structured data (ux/public/index.html) is pinned to them
 * by test so the public claims cannot drift from what the app enforces
 * (#2468: the site said 3 linked accounts while the gate allowed 2).
 *
 * No Node builtins. The web client may bundle this file.
 */

// Unique institutions (banks) a free account can link. Premium, trial and the
// onboarding funnel are unlimited; see requireWithinFreeInstitutionLimit.
const FREE_INSTITUTION_LIMIT = 2;

// Length of Budgit's one free Premium trial (backend/services/trialService.js).
// Named to match the service export; the env var TRIAL_DURATION_DAYS is a
// separate paid-checkout override and is not this value.
const AUTO_TRIAL_DURATION_DAYS = 90;

module.exports = {
  FREE_INSTITUTION_LIMIT,
  AUTO_TRIAL_DURATION_DAYS,
};
